import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";

const Evaluation = ({ RoutesClick, NcertClick }) => {
  const [registerModal, setRegisterModal] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activeTabHeader, setActiveTabHeader] = React.useState("Evaluation");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  const [form, setForm] = useState({
    name: "",
    email: "",
    role: "",
    gender: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Form submitted!\n" + JSON.stringify(form, null, 2));
    // Replace with actual submission logic
  };

  return (
    <div>
      <Header
        activeTab={activeTabHeader}
        handleTabClick={handleTabClickHeader}
        studentregisterModal={studentregisterModal}
        setStudentRegisterModal={setStudentRegisterModal}
        ParentregisterModal={ParentregisterModal}
        setParentRegisterModal={setParentRegisterModal}
        TeacherregisterModal={TeacherregisterModal}
        setTeacherregisterModal={setTeacherregisterModal}
        registerModal={registerModal}
        setRegisterModal={setRegisterModal}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
      />
      <div>
        <div className="feedBackBanner">
          <div className="bannerOverlayFF">
            <div className="f1">YOUR FEEDBACK MATTERS THE MOST</div>
            <div className="f2">
              The evaluation of NCERT KATBOOKs is an important step in enhancing
              the quality and effectiveness of digital learning resources.
            </div>
            <div className="f2">
              Your feedback will provide valuable insights on usability,
              relevance, and impact in actual teaching–learning environments.
            </div>
          </div>
        </div>

        <div className="f3">
          Every response will contribute towards refining the KATBOOKs to better
          serve the needs of students and teachers across the country.{" "}
        </div>

        <div className="containerF">
          <div className="title">Start a Conversation</div>
          <div className="subtitle">
            Your Journey to Educational Excellence Begins with Us
          </div>
          <form onSubmit={handleSubmit}>
            <div className="formGrid">
              <div className="formColumn">
                <label className="labels">
                  Name
                  <input
                    className="input"
                    name="name"
                    placeholder="Enter your name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </label>
                <label className="labels">
                  Are you a Teacher or Student?
                  <input
                    className="input"
                    name="role"
                    placeholder="Enter your mail id"
                    value={form.role}
                    onChange={handleChange}
                    required
                  />
                </label>
              </div>
              <div className="formColumn">
                <label className="labels">
                  Email ID
                  <input
                    className="input"
                    type="email"
                    name="email"
                    placeholder="Enter your mail id"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </label>
                <label className="labels">
                  Gender
                  <input
                    className="input"
                    name="gender"
                    placeholder="Male"
                    value={form.gender}
                    onChange={handleChange}
                  />
                </label>
              </div>
            </div>
            <label className="labels textareawid">
              Write your Message here
              <textarea
                className="textarea"
                name="message"
                placeholder="Tell us more..."
                value={form.message}
                onChange={handleChange}
                required
              />
            </label>
            <div className="buttonWrap">
              <button type="submit" className="button">
                Submit Response &nbsp; &rarr;
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer
        setActiveTab={setActiveTabHeader}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
      />
    </div>
  );
};

export default Evaluation;
